import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

import { pageKey } from '@drapejs/core';
import { computed, inject } from 'vue';
import useMeta from '@/composables/useMeta';


export default /*#__PURE__*/_defineComponent({
  __name: 'FullWidth',
  setup(__props) {

const page = inject(pageKey);

useMeta();
const blocks = computed(() => page?.value.blocks);

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(blocks))
      ? (_openBlock(), _createBlock(_component_blocks_repeater, {
          key: 0,
          blocks: _unref(blocks).Main
        }, null, 8, ["blocks"]))
      : _createCommentVNode("", true)
  ]))
}
}

})